import { OPEN_BRAKET, CLOSE_BRAKET, SLASH } from './char';
import { getUniqAttr, getNodeLength, appendToNode, attrsToString, attrValue, isTagNode } from './helpers';
const getTagAttrs = (tag, params)=>{
    const uniqAttr = getUniqAttr(params);
    if (uniqAttr) {
        const tagAttr = attrValue(tag, uniqAttr);
        const attrs = {
            ...params
        };
        delete attrs[String(uniqAttr)];
        const attrsStr = attrsToString(attrs);
        return `${tagAttr}${attrsStr}`;
    }
    return `${tag}${attrsToString(params)}`;
};
const renderContent = (content, openTag, closeTag)=>{
    const toString = (node)=>{
        if (isTagNode(node)) {
            return node.toString({
                openTag,
                closeTag
            });
        }
        return String(node);
    };
    if (Array.isArray(content)) {
        return content.reduce((r, node)=>{
            if (node !== null) {
                return r + toString(node);
            }
            return r;
        }, '');
    }
    if (content) {
        return toString(content);
    }
    return null;
};
export class TagNode {
    attr(name, value) {
        if (typeof value !== 'undefined') {
            this.attrs[name] = value;
        }
        return this.attrs[name];
    }
    append(value) {
        return appendToNode(this, value);
    }
    setStart(value) {
        this.start = value;
    }
    setEnd(value) {
        this.end = value;
    }
    get length() {
        return getNodeLength(this);
    }
    toTagStart({ openTag = OPEN_BRAKET, closeTag = CLOSE_BRAKET } = {}) {
        const tagAttrs = getTagAttrs(String(this.tag), this.attrs);
        return `${openTag}${tagAttrs}${closeTag}`;
    }
    toTagEnd({ openTag = OPEN_BRAKET, closeTag = CLOSE_BRAKET } = {}) {
        return `${openTag}${SLASH}${this.tag}${closeTag}`;
    }
    toTagNode() {
        const newNode = new TagNode(String(this.tag).toLowerCase(), this.attrs, this.content);
        if (this.start) {
            newNode.setStart(this.start);
        }
        if (this.end) {
            newNode.setEnd(this.end);
        }
        return newNode;
    }
    toString({ openTag = OPEN_BRAKET, closeTag = CLOSE_BRAKET } = {}) {
        const content = this.content ? renderContent(this.content, openTag, closeTag) : '';
        const tagStart = this.toTagStart({
            openTag,
            closeTag
        });
        if (this.content === null || Array.isArray(this.content) && this.content.length === 0) {
            return tagStart;
        }
        return `${tagStart}${content}${this.toTagEnd({
            openTag,
            closeTag
        })}`;
    }
    static create(tag, attrs = {}, content = null, start) {
        const node = new TagNode(tag, attrs, content);
        if (start) {
            node.setStart(start);
        }
        return node;
    }
    static isOf(node, type) {
        return node.tag === type;
    }
    constructor(tag, attrs, content){
        this.tag = tag;
        this.attrs = attrs;
        this.content = content;
    }
}
